import { Component, OnInit } from '@angular/core';
import {
  dateToSyncLists,
  dateToSyncTierLists,
  cdStates,
  nyStates,
  drugTier,
  nyDrugTier,
} from '@cigna/pdl-viewer/shared/util';
import { ActivatedRoute, Params } from '@angular/router';
import {
  FormularyFacade,
  FormularyRequest,
  TypeAHeadFacade,
  DropdownRequest,
  SearchMore,
} from '@cigna/pdl-viewer/drug-search/data-access';
import { FormGroup, FormControl } from '@angular/forms';
import moment from 'moment';

@Component({
  selector: 'cigna-pdl-viewer',
  templateUrl: './pdl-viewer.component.html',
  styleUrls: ['./pdl-viewer.component.scss'],
})
export class PdlViewerComponent implements OnInit {
  secondaryStateFormGroup = new FormGroup({
    secondaryDropControl: new FormControl(''),
  });

  selectDropDownList: DropdownRequest[] = [];
  urlParams: Params;
  formType: string;
  groupNumber: string;
  benefitOptionCode: string;
  eligibilitySystemCode: string;
  classId: string;
  selectedItem?: DropdownRequest;
  selectedStateCode: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  drugTableLoading: boolean;
  searchAlpha: string;
  isTherapeuticCode = false;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  showSearchInfo: boolean;
  isSecondaryStateDropShow = false;
  secondaryStateValue: string | undefined;

  constructor(
    private activRoute: ActivatedRoute,
    private _formularyFacade: FormularyFacade,
    private _typeAHeadFacade: TypeAHeadFacade,
  ) {}

  drugsList$ = this._formularyFacade.formularyDrugList$;
  otherInfo$ = this._formularyFacade.otherInformations$;
  typeaHead$ = this._typeAHeadFacade.typeaHead$;

  ngOnInit() {
    this.urlParams = this.activRoute.snapshot.queryParams;

    if (this.urlParams.indicator) {
      this.formType = this.urlParams.indicator === 'IFP' ? 'IFP' : 'nonIFP';
    } else {
      this.formType = this.activRoute.snapshot.data.noQueryDefault;
    }

    if (this.formType === 'IFP') {
      this.updateStateList();
    } else {
      this.updateTierList();
    }
  }

  updateStateList() {
    if (moment().isSameOrAfter(dateToSyncLists)) {
      this.selectDropDownList = nyStates;
    } else {
      if (this.urlParams.pdlYearType === 'NY') {
        this.selectDropDownList = nyStates;
      } else {
        this.selectDropDownList = cdStates;
      }
    }
  }

  updateTierList() {
    if (moment().isSameOrAfter(dateToSyncTierLists)) {
      this.selectDropDownList = nyDrugTier;
    } else {
      if (this.urlParams.pdlYearType === 'NY') {
        this.selectDropDownList = nyDrugTier;
      } else {
        this.selectDropDownList = drugTier;
      }
    }
  }

  stateTierChange(selectedValue: string) {
    this.drugTableLoading = false;
    this.isTherapeuticCode = false;
    this.secondaryStateValue = undefined;

    this.secondaryStateFormGroup.reset({
      secondaryDropControl: '',
    });

    this.selectedItem = this.selectDropDownList.find(
      (element: DropdownRequest) => element.value === selectedValue,
    );
    if (this.selectedItem?.drugTypes) {
      this.isSecondaryStateDropShow = true;
    } else {
      this.isSecondaryStateDropShow = false;
    }
    this.selectedStateCode = String(this.selectedItem?.code);
  }

  stateDrugTypeDropdown(selectedValue: string) {
    this.secondaryStateValue = selectedValue;
  }

  getDrugList(query: string) {
    this.drugTableLoading = true;
    this.isTherapeuticCode = false;
    const code = this.urlParams.pdlYearType;
    const requestParams: FormularyRequest = {
      formularyId: this.isSecondaryStateDropShow
        ? this.secondaryStateValue
        : this.selectedItem?.value,
      effectiveCode: code === 'NY' ? 'NY' : 'CD',
      searchQuery: query,
      details: true,
    };
    this._formularyFacade.loadFormularyDrugList(requestParams, true, false);
  }

  getTherapeuticDrugList(searchMore: SearchMore) {
    this.isTherapeuticCode = true;
    this.searchAlpha = '';
    this.drugTableLoading = true;
    const code = this.urlParams.pdlYearType;
    const requestParams: FormularyRequest = {
      formularyId: this.isSecondaryStateDropShow
        ? this.secondaryStateValue
        : this.selectedItem?.value,
      effectiveCode: code === 'NY' ? 'NY' : 'CD',
      therapeuticClassCode: searchMore.query,
    };
    this._formularyFacade.loadFormularyDrugList(requestParams, true, false);
  }

  callToTypeaHead(searchString: string) {
    const code = this.urlParams.pdlYearType;
    const formularyRequest: FormularyRequest = {
      searchQuery: searchString,
      formularyId: this.isSecondaryStateDropShow
        ? this.secondaryStateValue
        : this.selectedItem?.value,
      effectiveCode: code === 'NY' ? 'NY' : 'CD',
    };
    this._typeAHeadFacade.loadTypeaHead(formularyRequest, true);
  }
}
